import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  CurrentUser,
  UserListRequest,
  UserListResponse,
  WalletModel,
} from '@fantaz/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUserList(userList: UserListRequest): Observable<UserListResponse | null> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/username`;
    return this.http.post<UserListResponse>(endpoint, userList);
  }

  getCurrentUser(): Observable<CurrentUser | null> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/user/currentUser`;
    return this.http.get<CurrentUser>(endpoint);
  }

  getWallet(): Observable<WalletModel | null> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/wallet-status`;
    return this.http.get<WalletModel>(endpoint);
  }
}
